"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _ = require("..");

var _Box = _interopRequireDefault(require("../Box"));

var __jsx = _react["default"].createElement;
var resetStyles = {
  color: "inherit",
  textDecoration: "none",
  boxSizing: "border-box"
};

function LinkRaw_(props) {
  var sx = props.sx,
      innerRef = props.innerRef,
      restProps = (0, _objectWithoutProperties2["default"])(props, ["sx", "innerRef"]);

  var _splitSx = (0, _.splitSx)(sx),
      _splitSx2 = (0, _slicedToArray2["default"])(_splitSx, 2),
      css = _splitSx2[0],
      customSx = _splitSx2[1];

  return __jsx(_Box["default"], (0, _extends2["default"])({}, restProps, {
    _ref: innerRef,
    as: "a",
    sx: [resetStyles, css]
  }));
}

var LinkRaw$ = _react["default"].forwardRef(function (props, ref) {
  return __jsx(LinkRaw_, (0, _extends2["default"])({}, props, {
    innerRef: ref
  }));
});

var _default = LinkRaw$;
exports["default"] = _default;